import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PublicQuoteMasterLayoutComponent } from './public-quote-master-layout/public-quote-master-layout.component';
import { PublicQuoteHomeComponent } from './public-quote-home/public-quote-home.component';
import { ClientsComponent } from '../mnt-users/clients/clients.component';
import { PublicOrderComponent } from '../mnt-public-order/public-order/public-order.component';
import { PublicClientResetPasswordComponent } from './public-client-reset-password/public-client-reset-password.component';
import { BuilderUrlNotFoundComponent } from './builder-url-not-found/builder-url-not-found.component';
const routes: Routes = [
  {
    path: "",
    component: PublicQuoteMasterLayoutComponent,
    children: [
      {
        path: "",
        component: PublicQuoteHomeComponent,
      },
      {
        path: "quote",
        loadChildren: "app/mnt-public-quote/public-quote/public-quote.module#PublicQuoteModule"
      },
      {
        path: "invoices",
        loadChildren: "app/mnt-public-quote/public-quote/public-quote.module#PublicQuoteModule"
      },
      {
        path: "clients/listing/:clientID",
        component: ClientsComponent
      },
      {
        path: "invoice/:token",
        component: PublicOrderComponent
      },
      {
        path: "reset-password/:token",
        component: PublicClientResetPasswordComponent
      },
      {
        path: "not-found",
        component: BuilderUrlNotFoundComponent
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MntPublicQuoteRoutingModule { }



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/mnt-public-quote/mnt-public-quote-routing.module.ts